import { useEffect, useState } from 'react';

const MD_QUERY = '(min-width: 768px)';

function readMinWidthMd(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return true;
  }
  return window.matchMedia(MD_QUERY).matches;
}

/**
 * true cuando el viewport es ≥ md (768px).
 * Sin matchMedia (jsdom): asume desktop para no romper RTL.
 */
export function useMinWidthMd(): boolean {
  const [matches, setMatches] = useState(readMinWidthMd);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    const mq = window.matchMedia(MD_QUERY);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return matches;
}
